import { createFileRoute } from "@tanstack/react-router";
import { LivePortalPage } from "@/components/shared/LivePortalPage";
export const Route = createFileRoute("/portal.orders")({ component: Page });
function Page() {
  return (
    <LivePortalPage
      title="Orders"
      description="Live data from your KIZAK account."
      table="orders"
      filterField="customer_id"
      columns={[
        { key: "order_number", label: "Order" },
        { key: "total", label: "Total" },
        { key: "payment_status", label: "Payment" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
